import { jwtDecode } from 'jwt-decode';

import { leerLocal } from '../almacenamientoSeguro';

/**
 * ¿Hay una sesión que proteger con Face ID? Solo si la guardada aún no ha caducado.
 *
 * No basta con que haya algo guardado: una sesión caducada se queda en el móvil (la app lo
 * descubre al llamar a la API y lleva al login). Con ella, Face ID se ofrecía y bloqueaba la
 * pantalla de login, que no protege nada. Visto en la versión 5 de TestFlight (15-oct-2026).
 *
 * Solo lee la fecha de caducidad; la firma la comprueba la API, como siempre.
 */
export const haySesionAbierta = (): boolean => {
	const token = leerLocal('token');
	if (!token) {
		return false;
	}

	try {
		const { exp } = jwtDecode<{ exp?: number }>(token);

		return typeof exp === 'number' && exp * 1000 > Date.now();
	} catch {
		return false;
	}
};
